import { GridColDef } from '@mui/x-data-grid-premium'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import { CodeCell } from './CodeCell'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type CodeColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'code'> & {
  columnType: 'code'
}

export const getCodeColumn = <T extends GridValidRowModel>({
  columnType,
  style,
  ...config
}: CodeColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  renderCell: (params) => (
    <CodeCell dataTestId={config.getDataTestId ? config.getDataTestId(params) : undefined}>{params.formattedValue}</CodeCell>
  ),
})
